import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'


const baseUrl = process.env.REACT_APP_SERVER_URL;

export const projectApi = createApi({
    reducerPath: 'projectApi',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({

        allprojects: builder.query({
            query: ({ slug, page , isHome }) => {
                return {
                    url: slug ? `/projects?slug=${slug}&page=1` : isHome ? `/projects?isHome=${isHome}&page=${page}` : `/projects?page=${page}`,
                    method: 'Get',
                    credentials: 'include'
                }

            },
        }),

        projectDetail: builder.query({
            query: (id) => {
                return {
                    url: `/project/${id}`,
                    method: 'Get',
                    credentials: 'include'
                }

            },
        }),


    })
});

export const {

    useAllprojectsQuery,
    useProjectDetailQuery,

} = projectApi;

